<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Born and raised in Asia of Finnish missionary parents, Birgit Forsberg has lived most of her life in Asia, first in Sri Lanka and then in Thailand, working as a missionary and a housewife. After the unexpected death of her Thai-Chinese husband, she moved to her home country, where she has worked as a registered nurse until retirement.</p><br/>
<p style="text-indent:0em">A mother of three children and a grandmother of one nephew, she now works part-time. She lives with her husband, Johan, and their dog in a small town in Finland.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5b08c898